// utils/purchasePdf.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function downloadPurchasePdf({ formData, currency, files, logoDataUrl, meta = {} }) {
  const doc = new jsPDF({ unit: "pt", compress: true });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const primary = [25, 118, 210];
  const margin = 40;

  doc.setProperties({
    title: meta.title || "Purchase Request",

  });

  // helpers
  const safe = (v, fallback = "—") => (v === 0 || v ? String(v) : fallback);
  const getName = (v) => (v || "").split("|")[0] || "—";
  const fmtMoney = (v) => {
    const n = Number(v);
    return Number.isFinite(n)
      ? n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : safe(v);
  };
  const money = (v) => [currency || "", fmtMoney(v)].filter(Boolean).join(" ").trim();

  // HEADER (logo + title + PR No only; no subtitle text)
  const headerH = 82;
  doc.setFillColor(245, 247, 250);
  doc.rect(0, 0, pageWidth, headerH, "F");

  let cursorX = margin;
  if (logoDataUrl) {
    const w = 120, h = 30;
    doc.addImage(logoDataUrl, "PNG", cursorX, headerH / 2 - h / 2, w, h, undefined, "FAST");
    cursorX += w + 12;
  }

  doc.setFont("helvetica", "bold");
  doc.setTextColor(20, 20, 20);
  doc.setFontSize(18);
  doc.text(meta.title || "Purchase Request", cursorX, headerH / 2 - 6);

  // Show PR No at the right
  if (meta.requestId) {
    doc.setFont("helvetica", "bold");
    doc.setTextColor(33, 33, 33);
    doc.setFontSize(12);
  }

  // Section label
  const sectionLabel = (text, y) => {
    doc.setFont("helvetica", "bold");
    doc.setTextColor(33, 33, 33);
    doc.setFontSize(12);
    doc.text(text, margin, y);
  };

  // Files list (single cell)
  const filesList =
    files && files.length
      ? Array.from(files).map((f) => f.name).join(", ")
      : "—";

  // Everything in one details table (includes Requester Name here)
  const detailsRows = [
    ["Requester Name", safe(meta.requesterName)],        // 👈 moved to details
    ["Location", safe(formData.location)],
    ["Product Category", safe(formData.productCategory)],
    ["Product Name", safe(formData.productName)],
    ["Quantity", safe(formData.quantity)],
    ["Unit Price", money(formData.unitPrice)],
    ["Total Cost", money(formData.approxCost)],
    ["Expected Date", safe(formData.expectedDate)],
    ["Purchase Type", safe(formData.purchaseType)],
    ["Payment Type", safe(formData.paymentType)],
    ["Level-1 Approver", getName(formData.reportingTo)],
    ["Level-2 Approver", getName(formData.finance)],
    ["Level-3 Approver", getName(formData.higher_authority)],
    ["Product Description", safe(formData.productDescription)],
    ["Purchase Reason", safe(formData.productReason)],
    ["Comment", safe(formData.comment)],
    ["Files Attached", filesList],
  ];

  const tableStartY = headerH + 28;
  sectionLabel("PR Details", tableStartY);

  autoTable(doc, {
    startY: tableStartY + 10,
    head: [["Field", "Value"]],
    body: detailsRows,
    styles: { font: "helvetica", fontSize: 10, cellPadding: 6, textColor: [40, 40, 40] },
    headStyles: { fillColor: primary, textColor: 255, halign: "left" },
    alternateRowStyles: { fillColor: [250, 250, 250] },
    columnStyles: { 0: { cellWidth: 180, fontStyle: "bold", textColor: [30, 30, 30] } },
    tableWidth: pageWidth - margin * 2,
    margin: { left: margin, right: margin },
    didParseCell: (data) => {
      if (data.section === "body" && data.column.index === 1) {
        data.cell.styles.overflow = "linebreak";
      }
    },
  });

  // Footer
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(120, 120, 120);
    doc.text(`Page ${i} of ${pageCount}`, pageWidth - margin, pageHeight - 16, { align: "right" });
    doc.text("Generated by Expense Portal", margin, pageHeight - 16);
  }

  doc.save("purchase-request.pdf");
}
